export const OPERATIONS_ARE_NOT_ACTIVITY = [
  "deploy.requested",
  "deploy.started",
  "run.active",
  "run.usage",
  "run.spent",
  "run.tool.started",
  "run.tool.finished",
  "run.telemetry.dropped",
] as const;
